import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@repo/ui";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";
import type { WorkflowState } from "~/types/api";

export const useUpdateWorkflowState = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workflowId, state }: { workflowId: number; state: WorkflowState }) => {
      const response = await configurationApi.client.PATCH("/api/Workflow/{workflowId}/state", {
        params: { path: { workflowId } },
        body: { state },
      });

      if (response?.error) {
        const error = getErrorMessage(response.error, "Failed to update workflow status");
        throw new Error(error);
      }

      if (response?.response?.status < 200 || response?.response?.status > 299) {
        throw new Error("Unexpected response status: " + response.response.status);
      }

      return response.data;
    },
    onSuccess: () => {
      showToast("success", "Workflow status updated successfully");
      queryClient.invalidateQueries({
        queryKey: configurationApi.queryOptions("get", "/api/Workflow").queryKey,
      });
    },
    onError: (error: Error) => {
      showToast("error", error.message, "Failed to update workflow status");
    },
  });
};
